"use strict";

angular.module("customer")
.component("unreadNotification", {
    controller: unreadNotificationController,
    controllerAs: "unreadNotificationCtrl"
});

function unreadNotificationController($rootScope, $scope, $state, ModalService, common, UserService, $interval) {
    var isModalOpen = false;

    $scope.$on("$stateChangeSuccess", function(event, toState, toParams) {
       tryOpenModal(toState);
    });

    $rootScope.$on("UserUpdated", function() {
        tryOpenModal($state.current);
    });

    $rootScope.$on("CurrentNumbersUpdated", function() {
        tryOpenModal($state.current);
    });

    function tryOpenModal(state) {
        var hasNotification = $rootScope.CurrentNumbers && $rootScope.CurrentNumbers.notification_count > 0;
        var isNotificationState = state.name === "notification-history";
        var isAgreementAccept = $rootScope.user && !$rootScope.user.have_to_agree_tos;

        if (UserService.isLoggedIn() && isAgreementAccept && !isModalOpen && hasNotification && !isNotificationState) {
            openNotificationModal();
        }
    }

    function openNotificationModal() {
        isModalOpen = true;
        ModalService.showModal({
            templateUrl: require("./unread-notification.modal.html"),
            controller: "UnreadNotificationModalController",
            controllerAs: "notificationModalCtrl"
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function() {
                modal.element.remove();
                $interval(function(){
                    isModalOpen = false;
                    // delay to avoid reopen of modal when multiple events are called successively
                }, 500, 1);
            });
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./core/notification/unread-notification-modal/unread-notification.component.js
// module id = 879
// module chunks = 0